import { render, staticRenderFns } from "./MonotoringBlock.vue?vue&type=template&id=e2c38474&scoped=true"
import script from "./MonotoringBlock.vue?vue&type=script&lang=js"
export * from "./MonotoringBlock.vue?vue&type=script&lang=js"
import style0 from "./MonotoringBlock.vue?vue&type=style&index=0&id=e2c38474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c38474",
  null
  
)

export default component.exports